import type { GameMeta } from '@gmp/game-sdk';

/** Catalog data only (no rules or content), so menus can show the game without loading it. */
export const actOfNonsenseMeta = {
  id: 'act-of-nonsense',
  name: 'Act of Nonsense',
  tagline: 'A made-up word. Ten seconds of camera. Total commitment.',
  description: 'Everyone gets the same invented word and acts out what it means in a 10-second clip. Watch the performances, then vote.',
  minPlayers: 3,
  maxPlayers: 12,
  estimatedMinutes: [15, 25],
  usesMedia: true,
  modes: [
    { id: 'dictionary_disaster', name: 'Dictionary Disaster', description: 'Invent a meaning, perform it, vote for the funniest.' },
    { id: 'perfect_impostor', name: 'Perfect Impostor', description: 'One player secretly knows the real meaning. Everyone else acts a decoy. Find the insider.' },
    { id: 'double_act', name: 'Double Act', description: 'Pairs get matching roles, record separately from anywhere, and play side by side. Needs 5+ players.' },
  ],
  theme: { primary: '#b14dff', secondary: '#ffc531', background: '#1c0b2b', ink: '#fff4fb' },
  readiness: 'playable',
  genre: 'Acting and bluffing',
  controls: 'camera',
  category: 'party',
  instructions: [
    { icon: 'BookOpen', title: 'Meet the word', body: 'A fictional word appears. Nobody knows what it means. Yet.' },
    { icon: 'Video', title: 'Perform it', body: 'Record up to 10 seconds acting out your meaning. A photo pose works too.' },
    { icon: 'Theater', title: 'Showtime', body: 'Performances play anonymously on every phone and on the TV.' },
    { icon: 'Vote', title: 'Vote', body: 'Pick the funniest. In Perfect Impostor, find who had the real meaning.' },
  ],
} satisfies GameMeta;
